module.exports = __webpack_public_path__ + "3aa1b7954f03c6b37169ce3660c51032.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/Profile_Pic_Overlay.png
// module id = 156
// module chunks = 0